var aq;
(function (aq) {
    var ui;
    (function (ui) {
        var _ActivityOptimalStartDisplay = /** @class */ (function () {
            /* @ngInject */
            function _ActivityOptimalStartDisplay($scope, $translate, Restangular, resolver, Messages, OptimalStartService) {
                this.$scope = $scope;
                this.$translate = $translate;
                this.Restangular = Restangular;
                this.resolver = resolver;
                this.Messages = Messages;
                this.OptimalStartService = OptimalStartService;
            }
            _ActivityOptimalStartDisplay.prototype.$onInit = function () {
                var _this = this;
                this.isLoading = true;
                this.resolver(function () { return __awaiter(_this, void 0, void 0, function () {
                    var ostPromise, accountPromise, err_1;
                    var _a;
                    return __generator(this, function (_b) {
                        switch (_b.label) {
                            case 0:
                                _b.trys.push([0, 2, , 3]);
                                ostPromise = this.OptimalStartService.getOptimalStartById(this.activity.context.optimalstart);
                                accountPromise = this.Restangular.one('accounts', this.accountId).get({ single: true });
                                return [4 /*yield*/, Promise.all([ostPromise, accountPromise])];
                            case 1:
                                _a = _b.sent(), this.optimalStart = _a[0], this.account = _a[1];
                                this.isLoading = false;
                                this.contextLoadedCallback();
                                return [3 /*break*/, 3];
                            case 2:
                                err_1 = _b.sent();
                                this.isLoading = false;
                                this.noDataCallback();
                                this.Messages.error('Data failed to load');
                                throw err_1;
                            case 3: return [2 /*return*/];
                        }
                    });
                }); });
            };
            return _ActivityOptimalStartDisplay;
        }());
        ui.ActivityOptimalStartDisplay = {
            controller: _ActivityOptimalStartDisplay,
            controllerAs: 'vm',
            templateUrl: 'app/common/components/activities/contexts/optimalStartDisplay.html',
            bindings: {
                activity: '<',
                accountId: '<',
                building: '<',
                noDataCallback: '&',
                contextLoadedCallback: '&'
            }
        };
        angular
            .module('aq.ui')
            .component('activityOptimalStartDisplay', ui.ActivityOptimalStartDisplay);
    })(ui = aq.ui || (aq.ui = {}));
})(aq || (aq = {}));
